function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2.5,
  d: "M18.8 7.58V2.34a1 1 0 011.46-.9l21.2 10.7a1 1 0 01.56.9v20.14a1 1 0 01-1.44.9L3.1 16.15a1 1 0 00-1.43.9v20.79a1 1 0 00.55.9l21 10.69a1 1 0 001.44-.9v-6.15"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2.5,
  d: "M33.56 26.74v-6.33a1 1 0 00-.55-.89l-21.2-10.9a1 1 0 00-1.46.89v5.74M33.34 35.2v5.72a1 1 0 01-1.46.9l-20.9-10.9a1 1 0 01-.54-.89v-6.2"
});

function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 51,
    fill: "none",
    viewBox: "0 0 44 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.a53d7634.svg";
export { ForwardRef as ReactComponent };